import { createAction } from "@reduxjs/toolkit";

const vendorBusinessAddressActions = {
  setAddressValue: createAction(
    "vendor/kyb/business/address/setAddressValue",
    (key: string, value: string) => ({
      payload: { key, value },
    }),
  ),
  clearAddress: createAction("vendor/kyb/business/address/clearAddress"),
};

export default vendorBusinessAddressActions;
